import React, {useEffect} from 'react';

import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {components} from '../components';

export const ShippingAndPaymentInfo: React.FC = () => {
  const navigate = hooks.useAppNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderHeader = () => {
    return (
      <components.Header title='اطلاعات حمل و نقل و پرداخت' goBack={true} />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <div style={{padding: '40px 20px 20px 20px'}}>
        <custom.InputField
          placeholder='نام خود را وارد کنید'
          label='نام'
          icon={<svg.InputCheckSvg />}
          containerStyle={{marginBottom: 20}}
        />
        <custom.InputField
          placeholder='شماره تلفن خود را وارد کنید'
          label='شماره تلفن'
          containerStyle={{
            marginBottom: 20,
          }}
        />
        <custom.InputField
          placeholder='ایمیل خود را وارد کنید'
          label='ایمیل'
          containerStyle={{
            marginBottom: 20,
          }}
        />
        <custom.InputField
          placeholder='آدرس تحویل خود را وارد کنید'
          label='آدرس تحویل'
          containerStyle={{
            marginBottom: 20,
          }}
        />
        <custom.InputField
          placeholder='شماره کارت خود را وارد کنید'
          label='شماره کارت'
          containerStyle={{
            marginBottom: 20,
          }}
        />
        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 20,
          }}
        >
          <custom.InputField
            label='ماه / سال'
            placeholder='ماه / سال'
            containerStyle={{width: 'calc(50% - 5px)'}}
          />
          <custom.InputField
            label='cvv'
            placeholder='•••'
            containerStyle={{width: 'calc(50% - 5px)'}}
          />
        </div>
        <components.Button
          title='ادامه به پرداخت'
          onClick={() => {
            navigate('/Checkout');
          }}
        />
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
